import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import {
	FreudButtonModule,
	FreudCheckboxModule,
	FreudConfirmDialogModule,
	FreudLoaderModule,
} from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';
import { ZkInputModule } from '@zenklub/ng-ui';
import { CGISeverityModule } from 'modules/promptuary/components/cgi-severity/cgi-severity.module';
import { NgxMaskModule } from 'ngx-mask';
import { TooltipModule } from 'primeng/tooltip';
import { TabsRowModule } from 'shared/components/tabs-row/tabs-row.module';
import { ContactService } from 'shared/services/contact/contact.service';
import { PromptuaryService } from 'shared/services/promptuary/promptuary.service';
import { SharedModule } from 'shared/shared.module';

import { VCHistoryModule } from './components/vc-history/vc-history.module';
import { VCJitsi } from './components/vc-jitsi/vc-jitsi.component';
import { VideoConferencePage } from './components/vc-page/vc-page.component';
import { VCSCheduleAlertModule } from './components/vc-schedule-alert/vc-schedule-alert.module';
import { VCSidebar } from './components/vc-sidebar/vc-sidebar.component';
import { VCSwitch } from './components/vc-switch/vc-switch.component';
import { VCUserForm } from './components/vc-userform/vc-userform.component';
import { VCUserInfo } from './components/vc-userinfo/vc-userinfo.component';
import { SessionService } from './services/session/session.service';
import { VideoConferenceRoutes } from './video-conference.routes';

@NgModule({
	declarations: [
		VCJitsi,
		VCSidebar,
		VCSwitch,
		VCUserForm,
		VCUserInfo,
		VideoConferencePage,
	],
	imports: [
		CommonModule,
		FormsModule,
		FreudButtonModule,
		FreudLoaderModule,
		NgxMaskModule.forChild(),
		RouterModule.forChild(VideoConferenceRoutes),
		SharedModule,
		TooltipModule,
		TranslateModule.forChild(),
		ZkInputModule,
		FreudCheckboxModule,
		VCHistoryModule,
		FreudConfirmDialogModule,
		TabsRowModule,
		VCSCheduleAlertModule,
		CGISeverityModule,
	],
	providers: [PromptuaryService, ContactService, SessionService],
})
export class VideoConferenceModule {}
